module.exports = __webpack_public_path__ + "8a5cf6ea33198e7e74cc594c05f15d31.MP3";